module.exports = __webpack_public_path__ + "img/copy.ad33c4cb.svg";